
import axios from 'axios'
import { Message } from 'element-ui';
var phpUrlType = "dev" //线上 open /开发 dev
var javaUrlType = "dev" //线上 open /开发 dev
var wsType = "open"//线上 open /欧阳 ou
var phpUrl, javaUrl, wsUrl
// PHP接口
if (phpUrlType == "open") {// 线上
    phpUrl = 'https://api.parking.cxiot.cc'
} else if (phpUrlType == "dev") {// 开发
    phpUrl = 'https://api.parking.cxcamp.cn'
    // phpUrl = 'http://8.129.51.187:9805'
}
// Java接口
if (javaUrlType == "open") {// 线上
    javaUrl = 'https://api.parking.cxiot.cc'
} else if (javaUrlType == "dev") {// 开发
    javaUrl = 'https://api.parking.cxcamp.cn'
}
// ws
if (wsType == "open") {// 线上
    // wsUrl = 'wss://message.parking.cxiot.cc'
    wsUrl = 'ws://192.168.99.184:10002/ap'
} else if (wsType == "ou") {// 欧阳
    wsUrl = 'ws://192.168.5.51:12345/ws'
}

const Util = {
    searchURL: phpUrl + '/',
    operateURL: javaUrl + '/',
    wsURL: wsUrl,
    getCookie: (name) => {
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        if (arr) {
            return unescape(arr[2])
        } else {
            return null
        }
    },
    setCookie: (name, value, h) => {
        let exp = new Date()
        exp.setTime(exp.getTime() + h * 60 * 60 * 1000)
        document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + '; path=/'
    },
    // 强复制

    delCookie: (name) => {
        let exp = new Date()
        exp.setTime(exp.getTime() - 1)
        let cval = Util.getCookie(name)
        if (cval != null) {
            document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + '; path=/'
        }
    },
    superCopy: (obj) => {
        return JSON.parse(JSON.stringify(obj))
    },
    message(type, text) {
        if (type == "suc") {
            Message({
                message: text,
                type: 'success'
            })
        } else if (type == "war") {
            Message({
                message: text,
                type: 'warning'
            })
        } else if (type == "err") {
            Message.error(text)
        }

    },
    getNewTime(val, date) {
        let time
        if (val) {
            time = new Date(val)
        } else {
            time = new Date()
        }
        let y = time.getFullYear()
        let m = time.getMonth() + 1
        let d = time.getDate()
        let h = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        return date ? y + "-" + m + "-" + d : y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s
    },
    isNumber0(val) {
        return parseInt(val.replace(/[^\d]/g, ''))
    },
    isNumber1(val) {
        return val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, ".").replace(/^\./g, "").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
    },
    isNumber2(val) {
        return val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, ".").replace(/^\./g, "").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    },
    isNumber3(val) {
        return val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, ".").replace(/^\./g, "").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
    },
    // 反选省市区
    displayAreaCell(code, that, province, city, district) {
        if (code) {
            let provinceCode = code.substring(0, 2)
            let cityCode = code.substring(0, 4) + "00"
            //   获取市列表
            that.$http.post(`${Util.searchURL}utils/city/listAllByProvince`, {
                province: provinceCode
            }).then(
                res => {
                    if (res.data.code === 200) {
                        that.cityList = res.data.data
                        that.districtList = []
                        that[province] = provinceCode + "0000"
                    }
                },
                err => {
                    console.log(err);
                })
            //   获取区列表
            that.$http.post(`${Util.searchURL}utils/district/listAllByCity`, {
                city: cityCode
            }).then(
                res => {
                    if (res.data.code === 200) {
                        that.districtList = res.data.data
                        that[city] = cityCode
                        that[district] = code
                    }
                },
                err => {
                    console.log(err);
                })
        }
    },
    // post请求传参只传有值得
    getData(form) {
        let data={}
        for (let i in form) {
            if (form[i]) {
                data[i] = form[i]
            }
        }
        return data
    },
    objOfPropertyToArr(object) {
      var arr = [];
      var i = 0;
      for (var item in object) {
          arr[i] = item;
          i++;
      }
      return arr;
    },
    objOfValueToArr(object) {
      var arr = [];
      var i = 0;
      for (var item in object) {
          arr[i] = object[item];
          i++;
      }
      return arr;
    }
}

export default Util



// WEBPACK FOOTER //
// ./src/Util.js